export default __webpack_public_path__ + "static/media/Kia.4453b6e9.svg";